var HamazonFile = /** @class */ (function () {
    function HamazonFile() {
    }
    return HamazonFile;
}());
export { HamazonFile };
